import { ItemListPredicate, ItemPredicate } from '@blueprintjs/select';

import { BaseSelectItem, SelectItem } from 'bones/utils/select/types';

export const selectItemListPredicate =
  <
    SubItemType extends BaseSelectItem | null = null,
    ItemType extends SelectItem<SubItemType> = SelectItem<SubItemType>
  >({
    itemPredicate,
  }: {
    itemPredicate: (
      items: Array<SelectItem<SubItemType>>
    ) => ItemPredicate<SelectItem<SubItemType>>;
  }): ItemListPredicate<ItemType> =>
  (query: string, items: ItemType[]) => {
    if (!query) {
      return items;
    }

    const recursiveFilter = <T extends SelectItem<SubItemType> | null>(
      unfilteredItems: T[]
    ): T[] => {
      const nextItems: T[] = [];

      const itemFilter = (item: T): item is NonNullable<T> => Boolean(item);

      const filteredItems = unfilteredItems.filter(itemFilter);
      filteredItems.forEach((item) => {
        if (!itemPredicate(filteredItems)(query, item)) {
          return;
        }

        if (item.items) {
          const subItems = recursiveFilter(item.items);
          if (subItems.length) {
            nextItems.push({
              ...item,
              items: subItems,
            });
          }
        } else {
          nextItems.push(item);
        }
      });

      return nextItems;
    };

    return recursiveFilter(items);
  };
